import { createError, pad } from '../shared/common';

type CalendarDateParts = { year: number; month: number; day: number };

export const parseCalendarDateParts = (value: string): CalendarDateParts => {
  const [year, month, day] = value.split('-').map(Number);
  const normalized = new Date(value);

  if (
    normalized.getUTCFullYear() !== year ||
    normalized.getUTCMonth() !== month - 1 ||
    normalized.getUTCDate() !== day
  ) {
    throw createError(
      `Ожидалась корректная календарная дата, получено: ${value}`,
    );
  }

  return { year, month, day };
};

export const formatCalendarDateParts = ({
  year,
  month,
  day,
}: CalendarDateParts): string => `${pad(year, 4)}-${pad(month)}-${pad(day)}`;

export const fromNativeDate = (date: Date): CalendarDateParts => ({
  year: date.getUTCFullYear(),
  month: date.getUTCMonth() + 1,
  day: date.getUTCDate(),
});
